import { useOnlineStatus } from '../../hooks/useOnlineStatus'
import { Wifi, WifiOff } from 'lucide-react'

/**
 * Componente indicatore stato online/offline
 * Si mostra automaticamente quando offline
 */
export function OnlineIndicator() {
  const { isOnline, wasOffline } = useOnlineStatus()

  // Mostra solo se offline o appena tornato online
  if (isOnline && !wasOffline) return null

  return (
    <div
      className={`
        fixed top-0 left-0 right-0 z-50 px-4 py-2 text-center text-sm font-medium
        transition-all duration-300 transform
        ${isOnline 
          ? 'bg-green-500 text-white translate-y-0' 
          : 'bg-red-500 text-white translate-y-0'
        }
      `}
    >
      <div className="flex items-center justify-center gap-2">
        {isOnline ? (
          <>
            <Wifi className="h-4 w-4" />
            <span>Connessione ripristinata</span>
          </>
        ) : (
          <>
            <WifiOff className="h-4 w-4" />
            <span>Sei offline - Le modifiche verranno salvate quando tornerai online</span>
          </>
        )}
      </div>
    </div>
  )
}

export default OnlineIndicator
